import { useList } from '../../../api/react-query';

export function usePayoutEntities(props) {
  const { data, isLoading } = useList(
    'payoutEntities/list',
    { ...props?.params },
    '',
    'v1',
  );
  return { data: data?.data?.data, isLoading, count: data?.data?.total };
}
